export default {
      id: "wind-usage",
      viewBox: "0 0 13.708 11.411",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#wind",
      toString: function () {
        return this.url;
      }
    }